import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Loader } from 'ncoded-component-library';
import LeadContext from '../../../providers/Lead/Lead.context';
import { WithdrawButton } from '../WithdrawButton';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';
import useConfirmInterest from '../../../hooks/useConfirmInterest';

import './AcceptStepActions.styles.scss';

type AcceptStepActionsProps = {
  className?: string;
};

const AcceptStepActions: React.FC<AcceptStepActionsProps> = (props) => {
  const { className } = props;

  const [isWithdrawing, setIsWithdrawing] = useState(false);

  const {
    leadId,
    dealRoom: { _id: dealRoomId },
    enquiry: { _id: enquiryId },
    updateLead,
  } = useContext(LeadContext);

  const { isLoading: isConfirming, onConfirmInterest } = useConfirmInterest(
    leadId,
    enquiryId,
    updateLead,
  );

  const { t } = useTranslation();

  const classes = classNames('accept-step-actions', className);

  return (
    <div className={classes}>
      {(isWithdrawing || isConfirming) && <Loader />}

      <p className="title">
        <WarningExclamationIcon />
        {t('actionRequired')}
      </p>

      <p>{t('yourEnquiryHasBeenAccepted')}</p>

      <div className="actions">
        <Button variant="outline" onClick={onConfirmInterest}>
          {t('confirmInterest')}
        </Button>

        <WithdrawButton
          leadId={leadId}
          dealId={dealRoomId}
          isLoading={isWithdrawing}
          setIsLoading={setIsWithdrawing}
        />
      </div>
    </div>
  );
};

export default AcceptStepActions;
